import { render, staticRenderFns } from "./EventJustificationPolicy.vue?vue&type=template&id=418ad394&scoped=true&"
import script from "./EventJustificationPolicy.vue?vue&type=script&lang=ts&"
export * from "./EventJustificationPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./EventJustificationPolicy.vue?vue&type=style&index=0&id=418ad394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418ad394",
  null
  
)

export default component.exports